import { RootState } from "../../store";
import { EmailTemplateItem } from "../../model/EmailTemplateItem";
import { OrganizationKeyName } from "../../model/Organization";

export const allEmailTemplates = (
  state: RootState,
  org: OrganizationKeyName
): EmailTemplateItem[] => {
  return state.emailTemplate.emailTemplates[org] || [];
};

export const isLoadingEmailTemplates = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return state.emailTemplate.isLoadingEmailTemplates[org] || false;
};
